export const HEADER_HEIGHT = 25;
export const FOOTER_HEIGHT = 50;
export const NAVBAR_WIDTH = 50;
